import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';
import { ProjectService } from '../../../../services/project.service';
import { ProjectModel } from '../../../../services/project.model.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTitleService } from '../../../../services/core.title.service';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'project-admin-modules',
  template: require('./project.admin.modules.html')
})
export class ProjectAdminModulesComponent implements OnInit {
  @Input() project: any;
  @Input() modules: any;
  @Input() isProjectAdmin: any;

  data: any;
  moduleEnabled: any;
  showStandup = 1;

  standupChoices = {
    'Standups On': 1,
    'Standups Off': 0
  };

  constructor(
    private stateService: StateService, 
    
    private projectService: ProjectService,
    public projectModel: ProjectModel,
    private uiService: UiService,
    private titleService: GfTitleService
  ) {}

  ngOnInit(): void {
    this.data = this.projectModel.data;
    this.moduleEnabled = this.projectModel.moduleEnabled;

    this.projectModel.getAvailableScmModules().then(response => {
      // [#52381] Don't show CVS...
      this.data.availableScmModules = _.filter(_.get(response, 'items', []), module => module !== 'scmcvs');

      // [#52381] ...unless project is currently using CVS
      const currentScmIndex = _.findIndex(this.data.modules, (o: string = '') => o.match(/scm/i) !== null);
      const scmIndex = _.findIndex(this.data.availableScmModules, o => o === this.data.modules[currentScmIndex]);
      if (scmIndex === -1) {
        this.data.availableScmModules.push(this.data.modules[currentScmIndex]);
      }
    });

    this.projectModel.getShowStandups(this.project.id)
    .then( (response) => {
      this.showStandup = _.get(response, 'settingValue', 1);
    });

    // Set document title
    this.titleService.setTitle(this.project.name, 'Admin', 'Modules');
  }

  setStandupOn($event): void {
    this.showStandup = $event;
  }

  enableModule(event: any): void {
    const module = event.module;
    const enabled = event.enabled;

    if (enabled) {
      this.data.modules = [...new Set(_.concat(this.data.modules, [module]))];
    } else {
      this.data.modules = _.without(this.data.modules, module);
    }
  }

  enableScmModule(module: string): void {
    // Strip existing SCM modules and add the new one
    this.data.modules = _.difference(this.data.modules, this.data.availableScmModules)
      .concat([module]);
  }

  saveModules(): void {
    let newModules: string[];

    // Special case - putModules will not allow you to submit an empty list
    // (to prevent accidental disabling of all modules)
    // To disable all modules, you must submit the special module 'core'
    if (!Array.isArray(this.data.modules) || this.data.modules.length === 0) {
      newModules = ['core'];
    } else {
      newModules = this.data.modules;
    }
    this.data.saving = true;
    const unixName = this.stateService.params.unixName;

    const promises = [
      this.projectService.saveModules(unixName, _.join(newModules, ',')),
      this.projectService.saveShowStandups(this.project.id, this.showStandup)
    ];
    Promise.all(promises)
      .then(() => {
        // Reload permissions and module states for access checks.
        this.data.originalModules = _.cloneDeep(this.data.modules);
        this.data.saving = false;
        this.uiService.message.showSuccess('Your module changes were saved');
      })
      .catch(() => {
        this.data.modules = _.cloneDeep(this.data.originalModules);
        this.data.saving = false;
        this.uiService.message.showWarning('Sorry, could not update the modules for this project');
      })
      .finally(() => {
        this.stateService.go('.', {}, { reload: true });
      });

  }
}
